import type { LucideIcon } from 'lucide-react';
import { Database, Server, Warehouse, Globe, MessageSquare, FileText } from 'lucide-react';
import type { DatabaseDialect } from '@/types';

export type ConnectionCategory = 'databases' | 'productivity';
export type ConnectionStatus = 'available' | 'coming_soon' | 'new';
export type ConnectionKind = 'database' | 'atlassian';

export interface ConnectionTypeDefinition {
  id: string;
  name: string;
  description: string;
  category: ConnectionCategory;
  icon: LucideIcon;
  color: string;
  status: ConnectionStatus;
  kind: ConnectionKind;
  dialect?: DatabaseDialect;
}

export const CONNECTION_TYPES: ConnectionTypeDefinition[] = [
  // Databases
  {
    id: 'postgres',
    name: 'PostgreSQL',
    description: 'Open-source relational database with advanced features',
    category: 'databases',
    icon: Database,
    color: '#336791',
    status: 'available',
    kind: 'database',
    dialect: 'postgres',
  },
  {
    id: 'mysql',
    name: 'MySQL',
    description: 'Popular open-source relational database',
    category: 'databases',
    icon: Server,
    color: '#4479A1',
    status: 'available',
    kind: 'database',
    dialect: 'mysql',
  },
  {
    id: 'redshift',
    name: 'Amazon Redshift',
    description: 'Cloud data warehouse for analytics workloads',
    category: 'databases',
    icon: Warehouse,
    color: '#8C4FFF',
    status: 'available',
    kind: 'database',
    dialect: 'redshift',
  },
  // Productivity
  {
    id: 'atlassian',
    name: 'Atlassian',
    description: 'Connect Confluence and JIRA for knowledge and project management',
    category: 'productivity',
    icon: Globe,
    color: '#0052CC',
    status: 'new',
    kind: 'atlassian',
  },
  // Coming Soon
  {
    id: 'slack',
    name: 'Slack',
    description: 'Team messaging and collaboration platform',
    category: 'productivity',
    icon: MessageSquare,
    color: '#4A154B',
    status: 'coming_soon',
    kind: 'atlassian', // placeholder kind
  },
  {
    id: 'google-workspace',
    name: 'Google Workspace',
    description: 'Google Docs, Sheets, and Drive integration',
    category: 'productivity',
    icon: FileText,
    color: '#4285F4',
    status: 'coming_soon',
    kind: 'atlassian', // placeholder kind
  },
];

export const CONNECTION_CATEGORIES: { id: ConnectionCategory | 'all'; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'databases', label: 'Databases' },
  { id: 'productivity', label: 'Productivity' },
];
